import React from 'react';
import { Link } from "react-router-dom";
import { Grid, Container,Icon, Divider, Link as MUILink } from '@mui/material';
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import { Slide } from "react-awesome-reveal";

const About = ({data, parseContent, homepage}) => {
  return (
    <div id="About">
      <Container maxWidth="sm" sx={{my:2, py:2}} >  
        {homepage ? (<Grid sx={{pr:{xs:1,md:"16px"}}} justifyContent="space-evenly" alignItems="center" container>
          <Grid item xs={11} md={5} sx={{mb:3}}>
            <Slide direction="left">
              <div style={{ position:"relative", margin:"auto"}}>
                <div className="ab-shape-1"><img src={`${process.env.REACT_APP_PUBLIC_URL}/img/rightzigzag.png`} alt=""/></div>
                <div className="ab-shape-2"><img src={`${process.env.REACT_APP_PUBLIC_URL}/img/leftzigzag.png`} alt=""/></div>
                <img style={{width:"100%", height:"100%", objectFit:"cover"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/about/${data?.photos?.selectedImage}`} className="img-responsive" alt="" />
                {data?.phrase && <div  className="about-exprience"><h3>{data?.phrase}</h3></div>} 
              </div>
            </Slide>
          </Grid>
          <Grid item xs={11} md={5} sx={{ paddingTop:"10px", pl:{xs:1, lg:3}}}>
            {data?.title !== "" && <div className="section-title">
              <Slide direction="right">
                <h2 >{data ? data.title : "...loading"}</h2>
              </Slide>
            </div>}
            <div className="about-text">     
                {data ? data.paragraphs.map( (item,i) =>(
                  <Slide key={`item-${i}`} direction="right" delay={i * .1}>
                    <div>
                    {item.title !== "" && <h6 style={{marginBottom : 10, fontSize : 16}}>{item.title}</h6>}
                    <MDTypography variant="body2">{parseContent(item.content)}</MDTypography>
                    {Object.hasOwn(item, "link") && item.link  ?  <MUILink component={Link} sx={{display : "flex", width:"fit-content"}} className="custome-fancy-link-primary" to={item.link.slug}>Details <Icon fontSize="lg">trending_flat</Icon></MUILink> : null}
                    <Divider sx={{my:1}} />
                    </div>
                  </Slide>
                )) : "...loading!!"}
            </div>
          </Grid>
        </Grid>):(
        <MDBox display="block" gridGap="16px" alignItems="start">
          <MDBox
            component="img"
            src={`${process.env.REACT_APP_PUBLIC_URL}/img/about/${data?.photos?.selectedImage}`} 
            className="img-responsive" 
            alt={data?.title}
            sx={{ maxWidth: {xs  : "100%", lg : '50%'}, height: 'auto', objectFit:"cover", float: 'left', p :2 }}
          />
          {data?.title !== "" && <MDBox className="section-title" sx={{ "& h2" : {textAlign : "left","&::after":{left:"50% !important"}}}}>
              <Slide direction="right">
                <h2 >{data ? data.title : "...loading"}</h2>
              </Slide>
            </MDBox>}
            <div className="about-text">     
                {data ? data.paragraphs.map( (item,i) =>(
                  <Slide key={`item-${i}`} direction="right" delay={i * .1}>
                    <div>
                    {item.title !== "" && <h6 style={{marginBottom : 10, fontSize : 16}}>{item.title}</h6>}
                    <MDTypography variant="body2"> {parseContent(item.content)}</MDTypography>
                    {Object.hasOwn(item, "link") && item.link  ?  <MUILink component={Link} sx={{display : "flex", width:"fit-content"}} className="custome-fancy-link-primary" to={item.link.slug}>Details <Icon fontSize="lg">trending_flat</Icon></MUILink> : null}
                    <Divider sx={{my:1}} />
                    </div>
                  </Slide>
                )) : "...loading!!"}
            </div>
          <div style={{ clear: 'both' }} />
        </MDBox>)}

      </Container>
    </div>
  );
};
export default About;